import { ENV_LIT_NETWORK, getUrls } from '@shared/utils/config/environment';
import { deepConvertBigInt } from '@shared/utils/off-chain/deep-convert-bigint';
import { ChainId } from '@shared/utils/config/networks';
import { executeDirectTransactionsSolana } from '@shared/utils/solana/base/executeDirectTransactionsSolana';
import { createDBTransferReceipt } from '@/lib/db/DBTransferHistoryHelpers';
import { createTDBOrder } from '@/lib/db/DBOrderHelpers';
import { createDBOrderHistory } from '@/lib/db/DBOrderHistoryHelpers';
export default async function executeViaClientSolana({
  params,
  pkp,
  orderType,
  dbOrderParams,
  keypair,
  existingdbOrder,
  skipSimulation,
  transferParams
}) {
  var _a, _b, _c, _d;
  try {
    const tokenPrices = dbOrderParams === null || dbOrderParams === void 0 ? void 0 : dbOrderParams.tokenPrices;
    const toAssetPriceData = dbOrderParams === null || dbOrderParams === void 0 ? void 0 : dbOrderParams.toAssetPriceData;
    const dbOrderType = dbOrderParams === null || dbOrderParams === void 0 ? void 0 : dbOrderParams.dbOrderType;
    const priorityFee = (_a = params === null || params === void 0 ? void 0 : params.fees) === null || _a === void 0 ? void 0 : _a.priorityFee;
    const result = {
      message: `${orderType} client execution called`
    };
    const dbOrder = existingdbOrder ? existingdbOrder : (await createTDBOrder({
      cloud_wallet_address: pkp === null || pkp === void 0 ? void 0 : pkp.solanaAddress,
      order: params,
      pkp,
      token_prices: tokenPrices,
      order_type: dbOrderType,
      pkp_eth_address: pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress
    })).data;
    console.log('Executing order SOLANA dbOrder=>', dbOrder);
    const startTime = new Date().getTime();
    let executionResponse;
    const txns = ((_b = params === null || params === void 0 ? void 0 : params.transactions) === null || _b === void 0 ? void 0 : _b.swap) || ((_c = params === null || params === void 0 ? void 0 : params.transactions) === null || _c === void 0 ? void 0 : _c.transfer);
    if (!skipSimulation) {
      // Needs to be implemented
    }
    let executionResponseError = null;
    try {
      executionResponse = await executeDirectTransactionsSolana({
        transactions: txns.filter(x => x),
        keypair,
        priorityFee
      });
      if (executionResponse === null || executionResponse === void 0 ? void 0 : executionResponse.error) {
        throw new Error(`Error executing transaction: ${executionResponse === null || executionResponse === void 0 ? void 0 : executionResponse.error}`);
      }
    } catch (e) {
      executionResponseError = e === null || e === void 0 ? void 0 : e.message;
    }
    console.log('Executing order SOLANA client side', executionResponse, executionResponseError);
    const decodedResponse = {
      type: orderType,
      status: executionResponseError ? 'error' : 'success',
      error: executionResponseError === null || executionResponseError === void 0 ? void 0 : executionResponseError.error,
      note: 'Client side execution',
      quoteId: params === null || params === void 0 ? void 0 : params.quoteId,
      quote: params,
      transferTransaction: (orderType === null || orderType === void 0 ? void 0 : orderType.includes('WITHDRAW')) ? {
        network: ChainId.SOLANA,
        hash: executionResponse.txHash,
        status: 'success'
      } : null,
      swapTransactions: (txns === null || txns === void 0 ? void 0 : txns.length) > 1 && !(orderType === null || orderType === void 0 ? void 0 : orderType.includes('WITHDRAW')) ? [[{
        hash: executionResponse.txHash,
        network: ChainId.SOLANA,
        status: executionResponseError ? 'error' : 'success',
        explorerUrl: executionResponse === null || executionResponse === void 0 ? void 0 : executionResponse.explorerUrl,
        bundleId: executionResponse === null || executionResponse === void 0 ? void 0 : executionResponse.bundleId
      }, {
        hash: executionResponse.txHash1,
        network: ChainId.SOLANA,
        status: executionResponseError ? 'error' : 'success',
        explorerUrl: executionResponse.explorerUrl1,
        bundleId: executionResponse === null || executionResponse === void 0 ? void 0 : executionResponse.bundleId
      }]] : null,
      solanaSwapTransaction: (txns === null || txns === void 0 ? void 0 : txns.length) == 1 && !(orderType === null || orderType === void 0 ? void 0 : orderType.includes('WITHDRAW')) ? {
        hash: executionResponse.txHash,
        network: ChainId.SOLANA,
        status: executionResponseError ? 'error' : 'success',
        explorerUrl: executionResponse === null || executionResponse === void 0 ? void 0 : executionResponse.explorerUrl,
        bundleId: executionResponse === null || executionResponse === void 0 ? void 0 : executionResponse.bundleId
      } : null
    };
    console.log(`Executing order SOLANA ${orderType} client side`, executionResponse, 'decodedResponse', decodedResponse);
    const executionTime = new Date().getTime() - startTime;
    result['decodedResponse'] = decodedResponse;
    result['executionTime'] = executionTime;
    result['status'] = decodedResponse.status;
    let dbOrderHistory;
    if (orderType === null || orderType === void 0 ? void 0 : orderType.includes('WITHDRAW')) {
      const {
        token_address,
        token_amount,
        token_amount_formatted,
        usd_value,
        to_address,
        decimals,
        name,
        symbol,
        from_address,
        network
      } = transferParams;
      const wParams = {
        from_address,
        to_address,
        decimals,
        token_address,
        token_amount,
        token_amount_formatted,
        usd_value,
        type: 'withdraw',
        chain_id: isNaN(network) ? 0 : network,
        txn: executionResponse.txHash,
        token_metadata: JSON.stringify(deepConvertBigInt({
          symbol,
          name
        })),
        result: JSON.stringify(deepConvertBigInt({
          decodedResponse,
          executionTime
        }))
      };
      dbOrderHistory = (await createDBTransferReceipt(wParams)).data;
    } else {
      dbOrderHistory = (await createDBOrderHistory(deepConvertBigInt({
        order_id: dbOrder.id,
        cloud_wallet_address: pkp === null || pkp === void 0 ? void 0 : pkp.solanaAddress,
        status: decodedResponse.error ? 'error' : 'success',
        result: result,
        token_prices: tokenPrices,
        orchestrator_pkp: params === null || params === void 0 ? void 0 : params.orchestrator,
        token_out_prices: toAssetPriceData,
        execution_time: executionTime,
        pkp_eth_address: pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress
      }))).data;
    }
    console.log('Executing order SOLANA dbOrderHistory=>', dbOrderHistory);
    if (decodedResponse.status == 'success' && !(orderType === null || orderType === void 0 ? void 0 : orderType.includes('WITHDRAW'))) {
      try {
        const executorUrl = ((_d = getUrls()) === null || _d === void 0 ? void 0 : _d.EXECUTOR_URL) || 'https://staging-api.tradegenius.com';
        console.log('Executing order SOLANA executorUrl', executorUrl);
        const updateUrl = `/api/forwardGet?target=${executorUrl}/api/order/update-user-order?order_id=${dbOrder.id}&cloud_wallet=${pkp === null || pkp === void 0 ? void 0 : pkp.additionalEthAddress}`;
        console.log('Executing order SOLANA updateUrl=>', updateUrl);
        fetch(updateUrl);
      } catch (e) {
        console.log('Executing order SOLANA calling update url failed', e);
      }
    }
    console.log('Executing order SOLANA client side final', result, executionTime);
    return {
      result,
      dbOrderHistory,
      dbOrder,
      time: executionTime,
      litNetwork: ENV_LIT_NETWORK
    };
  } catch (e) {
    console.error('[executeViaClientSolana]', e);
    throw e;
  }
}